import { NonFieldError } from 'src/app/models/authentication';
import { DestroyRef, Directive, Input, OnInit, inject } from '@angular/core';
import { ControlContainer } from '@angular/forms';
import { Store, select } from '@ngrx/store';
import { map } from 'rxjs/operators';
import { IState } from 'src/app/reducers';
import { clearFormAndFieldErrors } from 'src/app/reducers/shared/shared.actions';
import { selectFormErrors } from 'src/app/reducers/shared/shared.selectors';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

export const NON_FIELD_ERRORS = 'non_field_errors';

@Directive({
  selector: 'form[formGroup][restoServerFormError]',
  standalone: true,
})
export class ServerFormErrorDirective implements OnInit {
  private form = inject(ControlContainer);
  private store = inject<Store<IState>>(Store);
  private destroyRef = inject(DestroyRef);

  @Input() formId!: string;

  private serverErrorShown = false;

  ngOnInit(): void {
    this.form?.valueChanges &&
      this.form.valueChanges
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe(() => {
          if (this.serverErrorShown) {
            this.serverErrorShown = false;
            this.store.dispatch(
              clearFormAndFieldErrors({
                payload: NON_FIELD_ERRORS,
              }),
            );
          }
        });
    this.store
      .pipe(
        select(selectFormErrors),
        map(
          (error) =>
            error?.[NON_FIELD_ERRORS] &&
            (error[NON_FIELD_ERRORS] as NonFieldError[]).find(
              (err) => err.form_id === this.formId || err.form_id === undefined,
            ),
        ),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe((error) => {
        if (!error) return;
        this.serverErrorShown = true;
        this.form?.control &&
          this.form.control.setErrors(
            { error: error?.message },
            { emitEvent: true },
          );
      });
  }
}
